import React, { useState, useEffect } from 'react';
import Parse from 'html-react-parser';

import './index.css';

export type Size = 'tiny' | 'small' | 'medium' | 'mediumBigFont' | 'big' | 'extraBig';
export type Position = 'moreLeft' | 'fullLeft' | 'left' | 'right' | 'fullRight' | 'top';

interface Props {
    id?: string,
    icon: string | React.ReactNode,
    color?: string,
    bgColor?: string,
    actBgColor?: string,
    onClick?: Function,
    disabled?: boolean,
    // tooltipId?: string,
    tooltip?: string | React.ReactNode
    tooltipPosition?: Position,
    badge?: {
        number: number,
        status: string
    },
    size?: Size,
    tooltipColor?: string,
    activedAfterClick?: boolean,
    sizeIconFontWeight?: string,
    notification?: boolean
    notificationLength?: number,
    colorNotification?: string,
    backgroundColorIcon?: string
    degrade?: boolean,
}

const LcIconLink: React.FC<Props> = (props) => {
    const disabled = props.disabled || false;
    const [clickActive, setClickActive] = useState<boolean>(false);

    useEffect(() => {
        setClickActive(false);
    }, [])

    const handleClick = () => {
        props.onClick && props.onClick();
        setClickActive(!clickActive);
    }

    return (
        <div
            id={props.id}
            className={`lciconlink${(disabled) ? ' disabled' : ''} ${props.size || ''}${(props.activedAfterClick) ? ' active' : ''}`}
            onClick={() => !disabled && handleClick()}
            style={{
                backgroundColor: (props.activedAfterClick && props.actBgColor) ? props.actBgColor : props.bgColor
            }}
            onMouseLeave={() => setClickActive(false)}
        >
            <>
                {
                    props.notification &&
                    <div className="notification"
                        style={{
                            backgroundColor: props.colorNotification,
                            color: (props.colorNotification === '#E64646') ? '#fff' : '#000'
                        }}>
                        <p>{props.notificationLength}</p>
                    </div>
                }
                {
                 typeof props.icon === 'string'  ?
                    <i
                        className={`${props.icon} ${props.degrade ? 'degrade' : ''}`}
                        style={{ color: (props.activedAfterClick && props.activedAfterClick === true) ? "#fff" : props.color }}
                    />
                    : props.icon
                }
            </>
            {
                props.badge && props.badge.number > 0 &&
                <div className={`badge bg-${props.badge.status}`}>
                    <span> {(props.badge.number > 99) ? '+99' : props.badge.number} </span>
                </div>
            }
            {
                props.tooltip && clickActive == false &&
                <div className="tooltip">
                    <div className="body">
                        <div className={`content ${props.tooltipPosition || ''}`} style={{ backgroundColor: props.tooltipColor, zIndex: 1000 }}>
                            {
                                (typeof props.tooltip === 'string')
                                    ? <p>{Parse(props.tooltip)}</p>
                                    : props.tooltip
                            }
                        </div>
                        <span className={`arrow  ${props.tooltipPosition || ''}`} style={{ backgroundColor: props.tooltipColor }} />
                    </div>
                </div>
            }
        </div>
    );
}

export default LcIconLink;